import QRCode from 'qrcode';

// Generate a QR PNG data URL for overlay rendering.
export async function generateQrDataUrl(data: string): Promise<string | null> {
  if (!data) return null;
  try {
    return await QRCode.toDataURL(data, { margin: 1, width: 512 });
  } catch {
    return null;
  }
}

// Map qr size keyword to CSS pixel size (mirrors QRView.toQRSize dp values).
export function qrSizePx(size: string): number {
  switch (size) {
    case 'large':
      return 320;
    case 'medium':
      return 160;
    default:
      return 80;
  }
}

// Absolute-positioning CSS (kebab-case, units included) for a QR overlay,
// derived from a "top|left" gravity string. Mirrors QRView.toGravity().
export function qrPositionStyle(position: string): Record<string, string> {
  const parts = position.split('|').map((p) => p.trim());
  const style: Record<string, string> = { position: 'absolute', margin: '20px' };

  const vertical = parts.find((p) => p === 'top' || p === 'bottom');
  const horizontal = parts.find(
    (p) => p === 'left' || p === 'start' || p === 'right' || p === 'end',
  );

  if (vertical === 'top') style.top = '0';
  else style.bottom = '0';

  if (horizontal === 'left' || horizontal === 'start') style.left = '0';
  else style.right = '0';

  if (parts.includes('center')) {
    style.left = '50%';
    style.right = 'auto';
    style.transform = 'translateX(-50%)';
  }

  return style;
}
